import styled from 'styled-components';

export const MyCompanyEditActionButtons = styled.section`
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
`;

export const MyCompanyAnalyticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
`;
